export default "__VITE_ASSET__Dt6ALMRE__"